import AbstractScene from './AbstractScene.js';
import RoundedButton2 from '../prefabs/RoundedButton2.js';
import { Colors } from '../consts/Colors.js';
import Popup from '../prefabs/Popup.js';
import PopupFin from '../prefabs/PopupFin.js';
import { TextContents, CartesInfos, ZonesInfos } from '../consts/DataGame2.js';
import { tags } from '../consts/Tags.js';
import Deck2 from '../prefabs/game2/Deck2.js';
import Zone2 from '../prefabs/game2/Zone2.js';

export default class Game2 extends AbstractScene {
    constructor() {
        super({
            key: "Game2"
        })
    }
    init(data) {
        this._init(data);
        this.zonesInfos = ZonesInfos;
    }

    preload() {
        this._preload();
        this.cameras.main.setBackgroundColor(Colors.Text.Beige);
    }

    create() {
        console.log('Create :',this.scene.key);
        CartesInfos.sort(() => Math.random() - 0.5);

        this.transitionRect = this.add.rectangle(0, 0, 1920, this.height, Colors.Elmt.DarkBlue, 1).setOrigin(0, 0).setDepth(12)

        // Ajout elements du fond
        let background = this.add.sprite(720, 540, "backGame2")

        // Ajout element interactifs
        this.addDropZone()

        this.deck1 = new Deck2(this, 1700, 540, 336, 490);
        this.deck1.setDeckAction(CartesInfos[0])

        this.transitionIn()
    }

    launchPopup() {
        this.popup = new Popup(this, TextContents.popup.text, 756, false);
        this.popup.introBtn.setClickFunction(() => {
            this.popup.destroy();
            this.zones.getChildren().forEach(zone => {
                zone.setActive();
            });
        })
    }

    launchEndPopup() {
        this.popup = new PopupFin(this, TextContents.popupFin.text, 756);
        this.popup.introBtn.setClickFunction(() => {
            this.transitionOut()

        })
    }


    addDropZone() {
        this.zones = this.add.group();
        this.zonesInfos.forEach( zoneInfo => {
            let newZone = new Zone2(this, zoneInfo)
            this.zones.add(newZone)
        })
    }
    resetDropZones(){
        this.zones.getChildren().forEach(zone => {
            zone.reset()
        });
    }

    getZoneByCarteIndex(index){
        let foundZone = null
        this.zones.getChildren().forEach(zone => {
            if(zone.zoneCarteId === index){
                foundZone = zone
            }
        })
        return foundZone
    }

    transitionIn() {
        // this.transitionRect.setAngle(180);
        let X = 1480
        this.tweens.add({
            targets: this.transitionRect,
            duration: 500,
            ease: 'Linear',
            width: this.width-X,
            x: X,
            onComplete: () => {
                this.transitionRect.setDepth(-1)
                this.launchPopup();
            }
        })

    }

    transitionOut() {
        this.tweens.add({
            targets: this.deck1,
            duration: 500,
            alpha: 0,
            onComplete: () => {
                this.transitionRect.setDepth(12)
                this.tweens.add({
                    targets: this.transitionRect,
                    x: 0,
                    duration: 500,
                    onUpdate: () => {
                        this.transitionRect.width = 1920 - this.transitionRect.x;
                        // this.transitionRect.x = 1904 - this.transitionRect.width
                    },
                    onComplete: () => {
                        this.nextScene()
                    }
                })
            }
        })
    }
}